import { Box, CircularProgress } from "@material-ui/core";
import React from "react";

const LoadingSpinner = ({ fullScreen = false, size = 40 }) => {
	const content = <CircularProgress size={size} className="text-primary-700" />;

	if (fullScreen) {
		return (
			<Box className="fixed inset-0 flex justify-center items-center bg-white/80 z-[9999]">
				{content}
			</Box>
		);
	}

	return <Box className="flex justify-center items-center p-8">{content}</Box>;
};

export default LoadingSpinner;
